<template>
    <div>
        <topnav @tosearch="tosearch" :keywords="keyword" :types="type" :isSearch="1"></topnav>
        <div style="min-height: 600px">
           <div class="line"></div>
           <div v-if="type == 1" class="marginauto conwidth" style="padding: 10px 0 50px 0;">
               <div v-for="(item,index) in list" :key="index" class="newone flex pointer " @click="todetail(item.id)" style="padding: 40px 0;border-bottom: 1px solid #eee;">
                   <div class="flex flex-direction justify-center aling-center" style="width: 212px;height: 212px;background-color: #416ec4;">
                      <div class="text-white text-center" style="font-weight: 600;font-size: 80px;">{{item.day}}</div>
                      <div class="text-white text-center" style="font-weight: 400;font-size: 24px;">{{item.year}}/{{item.month}}</div>
                   </div>
                   <div class="flex-sub" style="padding: 0 30px;">
                        <div class="text-cut" style="color: #2d2d2d;font-size: 22px;padding: 20px 0;">{{item.title}}</div>
                        <div class="text-cut2" style="line-height: 30px;font-size: 18px;margin: 15px 0;min-height: 60px;" v-html="item.content">

                        </div>
                        <div class="flex justify-between align-start" style="margin-top: 15px;">
                            <div class="" style="color: #888888;font-size: 18px;">{{item.small_title}}</div>
                            <div class="detail pointer">
                                了解详情→
                            </div>
                        </div>
                   </div>
               </div>
               <div v-if="!list.length && !load" style="min-height: 600px">
                   <nomore text="暂无信息服务"></nomore>
               </div>
           </div>
           <div v-if="type == 2" class="bggray response" style="padding: 40px 0;">
                <div class="marginauto conwidth">
                    <div class="flex justify-between flex-wrap align-center response">
                        <div class="cone" v-for="(item,index) in list" :key="index">
                            <el-image style="width: 268px;height: 268px;" :src="item.image | addurl" fit="fill"></el-image>
                            <div class="" style="padding: 20px 0;">
                                <div class="text-cut" style="color: #1a1a1a;font-size: 23px;margin-bottom: 30px;">
                                    {{item.name}}
                                </div>
                                <div class="text-cut" style="color: #606060;font-size: 20px;">
                                    {{item.company}}
                                </div>
                            </div>
                            <div class="flex justify-between align-center">
                                <div @click="todetail(item.id)" class="dbtn pointer">详情</div>
                                <div class="dright">{{item.question_number}}人咨询</div>
                            </div>
                        </div>
                    </div>
                    <div v-if="!list.length && !load" class="" style="min-height: 500px">
                        <nomore text="暂无技术服务"></nomore>
                    </div>
                </div>
            </div>
                <div class="text-center" v-if="!list.length" style="padding: 40px 0;">
                    <el-pagination
                        background
                        layout="prev, pager, next"
                        
                        :hide-on-single-page="true"
                        :page-size="pagesize"
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="currentPage"
                        :total="totalnum"
                        >
                        </el-pagination>
                </div>
        </div>
    </div>
</template>
<script>
// import { mapGetters } from "vuex";
import nomore from '../components/nomore.vue';
export default {
    computed: {
        // ...mapGetters(["config"]),
    },
  components: { nomore },
    data() {
        return{
            load: true,
            pagesize: 10,
            totalnum: 0,
            currentPage: 1,
            pagercount: 7,
            list: [],
            keyword: '',
            type: 1
        }
    },
    methods:{
        todetail(id){
            if(this.type == 2){
                this.$router.push({path: '/techdetail',query:{id: id}})
            }else if(this.type == 1){
                this.$router.push({path: '/policydetail',query:{id: id,type: 0}})
            }
        },
        handleSizeChange(){

        },
        handleCurrentChange(currentPage){
            this.currentPage = currentPage;
            this.getlist();
        },
        getlist(){
            if(this.type == 1){
                var data = {
                    type: 0,
                    start: this.currentPage,
                    page_size: this.pagesize,
                    keyword: this.keyword
                }
                this.$api.index.server_list(data).then(res => {
                    this.list = res.data;
                    this.totalnum = res.count;
                    this.load = false;
                })
            }else if(this.type == 2){
               var data = {
                    first_id: 0,
                    second_id: 0,
                    start: this.currentPage,
                    page_size: this.pagesize,
                    keyword: this.keyword
                }
                this.$api.index.tech_list(data).then(res => {
                    this.list = res.data;
                    this.totalnum = res.count;
                    this.load = false;
                }) 
            }
            
        },
        tosearch(data){
            console.log(data)
            var data = JSON.parse(data);
            this.keyword = data.keyword;
            this.type = data.type;
            this.list = [];
            this.currentPage = 1;
            this.totalnum = 0;
            this.getlist();
        }
    },
    created(){
        this.keyword = this.$route.query.keyword;
        this.type = this.$route.query.type;
        console.log('this.type',this.type)
        this.getlist();
    }
}
</script>
<style scoped>
    .line{
        width: 100%;
        height: 14px;
        background-color: #eef1fa;
    }
    .topall{
        padding: 45px 0;
    }
    .topone{
        padding: 8px 18px;font-size: 16px;color: #4e4e4e;
    }
    .active{
        background-color: #ebf8ff;
	    border-radius: 4px;color: #1759d8;
    }
    .detail{
        color: #888888;font-size: 16px;
        width: 130px;
        height: 35px;
        line-height: 35px;text-align: center;
        background-color: #ffffff;
        border: solid 1px #888888;
    }
    .detail:hover{
        background-color: #1759d8;
        color: #eee;
        border-color: #1759d8;
    }


    .bggray{
        background-color: #eef1fa;
    }
    .topall{
        padding: 45px 0;
        background-color: #fff;
    }
    .topone{
        padding: 8px 18px;font-size: 16px;color: #4e4e4e;
    }
    .active{
        background-color: #ebf8ff;
	    border-radius: 4px;color: #1759d8;
    }
    .cone{
        width: 263px;background-color: #ffffff;
        padding: 25px;margin-bottom: 15px;
    }
    .colorone{
        color: #ffa10e;font-size: 20px;
    }
    .colortwo{
        color: #1e1e1e;font-size: 18px;
        width: 80px;
    }
    .csbtn{
        height: 48px;width: 100%;
        line-height: 48px;
        background-image: linear-gradient(86deg, 
        #005aeb 0%, 
        #00a0fd 100%);
        border-radius: 3px;font-size: 18px;color: #fff;
    }
    .dbtn{
        width: 120px;color: #fff;text-align: center;
        height: 35px;line-height: 35px;
        background-color: #ffab18;
        border-radius: 4px;font-size: 18px;
    }
    .dright{
        color: #a7a7a7;font-size: 18px;
    }
</style>


// WEBPACK FOOTER //
// search.vue?3862b339